import AdaptiveDatePicker from "app/components/AdaptiveDatePicker";
import clsx from "clsx";
import React, { useState } from "react";
import { dateFormatter } from "utils/helpers";

interface Props {
  onChange: (date: string) => void;
  placeholder: string;
  value: string;
  error?: string;
}

const DateSelection: React.FC<Props> = ({
  onChange,
  placeholder,
  value,
  error,
}) => {
  const [dateValue, setDateValue] = useState<Date | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleChange = (val) => {
    setDateValue(val);
    onChange(val ? val.toISOString() : "");
  };

  return (
    <div className="w-full">
      <AdaptiveDatePicker
        className="!h-[42px] border-t-0 rounded-none"
        value={dateValue}
        onChange={(v) => {
          handleChange(v);
        }}
        isDisablePastDate
        placeholder={placeholder}
        trigger={
          <button
            className={clsx(
              "flex items-center justify-start gap-[8px] h-[42px]  px-2 w-full ",
              error
                ? "border-danger"
                : isOpen
                  ? "border border-secondary"
                  : "",
            )}
          >
            <span className=" text-sm text-black font-normal ">
              {value ? (
                dateFormatter(value)
              ) : (
                <span className=" text-[11px] text-secondary ">-</span>
              )}
            </span>
          </button>
        }
        setOpen={setIsOpen}
        onClose={() => {
          setIsOpen(false);
        }}
      />
    </div>
  );
};

export default DateSelection;

